const metrics = {}

export default metrics
